import { render, staticRenderFns } from "./AnagramsPreview.vue?vue&type=template&id=82063ca8&lang=pug&"
import script from "./AnagramsPreview.vue?vue&type=script&lang=js&"
export * from "./AnagramsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports